import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueRouter from 'vue-router'
import App from './App.vue'
import ThirdPage from './views/ThirdPage'
import BlockedPage from './views/BlockedPage'
import {
  buildLandingRoutes,
  createRouteGuard,
  fetchLandingRouteConfig
} from './landingRouteConfig'

Vue.use(VueRouter)
Vue.use(ElementUI)

/**
 * 去掉旧版 #/ 中的 query 参数，裸路径不再自动跳转到广告入口。
 */
function normalizeEntryUrl() {
  try {
    const loc = window.location
    const hash = loc.hash || ''
    let pathname = loc.pathname || '/'
    const params = new URLSearchParams(loc.search)

    if (hash.startsWith('#/')) {
      const hashContent = hash.slice(2)
      const qIndex = hashContent.indexOf('?')
      const pathPart = qIndex >= 0 ? hashContent.slice(0, qIndex) : hashContent
      const queryPart = qIndex >= 0 ? hashContent.slice(qIndex + 1) : ''
      const hashPath = pathPart ? `/${pathPart.replace(/^\//, '')}` : '/'
      if (hashPath !== '/') {
        pathname = hashPath
      }
      if (queryPart) {
        new URLSearchParams(queryPart).forEach((value, key) => {
          if (!params.has(key)) {
            params.set(key, value)
          }
        })
      }
    }

    if (pathname.endsWith('/index4.html')) {
      pathname = '/'
    }

    const query = params.toString()
    const nextUrl = `${pathname}${query ? `?${query}` : ''}`
    const currentUrl = `${loc.pathname}${loc.search}${hash}`

    if (nextUrl !== currentUrl) {
      window.history.replaceState(null, '', nextUrl)
    }
  } catch (e) {
    // ignore
  }
}

normalizeEntryUrl()

async function bootstrap() {
  const routeConfig = await fetchLandingRouteConfig()
  const { isAllowedPath, fallbackPath } = createRouteGuard(routeConfig)
  const routes = buildLandingRoutes(routeConfig, { ThirdPage, BlockedPage, fallbackPath })

  const router = new VueRouter({
    mode: 'history',
    routes
  })

  router.beforeEach((to, from, next) => {
    if (to.path === '/index4.html') {
      next(to.fullPath.includes('/pay-success') ? '/pay-success' : fallbackPath())
      return
    }

    if (!isAllowedPath(to.path) && to.path !== '/blocked') {
      next({ path: fallbackPath(), replace: true })
      return
    }

    next()
  })

  new Vue({
    router,
    render: h => h(App)
  }).$mount('#app')
}

bootstrap()
